import TextFieldControl from "components/form/TextFieldControl";
import { UseFormReturn } from "react-hook-form";
import SelectCandidateType from "components/SelectCandidateType";
import VALIDATION from "helpers/validation";
import useIsCreate from "hooks/useIsCreate";
import ReportSwitch from "pages/Testing/view/components/ReportSwitch";
import CandidateInfo from "./CandidateInfo";
import { InfoInputs } from "../types";

interface InfoTabLeftProps {
  isEditing: boolean;
  form: UseFormReturn<InfoInputs>;
}

const InfoTabLeft = ({ isEditing, form }: InfoTabLeftProps) => {
  const isCreate = useIsCreate();
  const { reset, getValues } = form;

  const resetCandidateFields = () => {
    reset({
      ...getValues(),
      candidate: {
        email: "",
        phoneNumber: "",
        organization: "",
        position: "",
        grade: null,
        telegramUsername: null,
        login: null,
        fullName: null,
        id: null,
      },
    });
  };

  return (
    <>
      <ReportSwitch />
      <SelectCandidateType
        resetCandidateFields={resetCandidateFields}
        isEditing={isEditing}
      />
      <CandidateInfo
        form={form}
        isEditing={isEditing}
        resetCandidateFields={resetCandidateFields}
      />
      <TextFieldControl
        name='title'
        label='Название тестирования'
        disabled={!isEditing}
        rules={{ ...VALIDATION.competencyMapTitle }}
      />
      <TextFieldControl
        name='comment'
        label='Комментарий к тестированию'
        minRows={6}
        disabled={!isEditing || isCreate}
        multiline
      />
    </>
  );
};

export default InfoTabLeft;
